var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view'),(_vm.hasIdCompany && _vm.$route.name !== 'timeline')?_c('floating-chat',{attrs:{"idPerson":_vm.person._id,"sender":_vm.userProfile.name}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }